import React, { useMemo } from 'react';
import styled from 'styled-components';
import RichTextEditor from 'react-rte';
import theme from '../theme';

const MarkdownContent = ({ markdown }) => {
  const html = useMemo(() => {
    if (!markdown || !markdown.trim()) return '';
    try {
      return RichTextEditor.createValueFromString(markdown, 'markdown').toString('html');
    } catch {
      return `<p>${markdown}</p>`;
    }
  }, [markdown]);

  if (!html || html === '<p><br></p>') {
    return <EmptyText>No content</EmptyText>;
  }

  return <ContentWrapper dangerouslySetInnerHTML={{ __html: html }} />;
};

const ContentWrapper = styled.div`
  font-family: ${theme.typography.fontFamily};
  font-size: ${theme.typography.body.size};
  line-height: 1.7;
  color: ${theme.colors.text};
  overflow-wrap: break-word;
  word-break: break-word;
  max-width: 100%;
  min-width: 0;

  h1, h2, h3, h4, h5, h6 {
    color: ${theme.colors.text};
    margin: 0 0 ${theme.spacing.sm} 0;
    font-weight: 600;
  }
  h1 { font-size: 20px; }
  h2 { font-size: 18px; }
  h3 { font-size: 16px; }

  p {
    margin: 0 0 ${theme.spacing.sm} 0;
    &:last-child { margin-bottom: 0; }
  }

  ul, ol {
    margin: 0 0 ${theme.spacing.sm} 0;
    padding-left: 24px;

    ${theme.media.mobile} {
      padding-left: 18px;
    }
  }

  li {
    margin-bottom: 4px;
  }

  a {
    color: ${theme.colors.primary};
    text-decoration: none;
    &:hover { text-decoration: underline; }
  }

  blockquote {
    border-left: 3px solid ${theme.colors.primary};
    margin: 0 0 ${theme.spacing.sm} 0;
    padding: ${theme.spacing.sm} ${theme.spacing.md};
    background: ${theme.colors.primaryGhost};
    border-radius: 0 ${theme.radii.sm} ${theme.radii.sm} 0;
  }

  strong { font-weight: 600; }

  code {
    background: ${theme.colors.background};
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 13px;
  }
`;

const EmptyText = styled.span`
  color: ${theme.colors.textMuted};
  font-size: ${theme.typography.small.size};
  font-style: italic;
`;

export default MarkdownContent;
